"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var React = _interopRequireWildcard(require("react"));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ic_birthday__greeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 192 192"
  }, props), /*#__PURE__*/React.createElement("title", null, "birthday-greeting-mid"), /*#__PURE__*/React.createElement("g", {
    id: "24d1b330-0c9f-4d91-a11e-9492a31b03f6",
    "data-name": "ICON"
  }, /*#__PURE__*/React.createElement("path", {
    id: "94a34bab-4544-47e5-9dac-da7be30a09a0",
    "data-name": "<Pfad>",
    d: "M44,68c-6,2.69-10,8.54-10,12,0,9.42,28.87,22,62,22s62-12.58,62-22c0-3.46-4-9.31-10-12",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "b34de4fb-8eee-44c2-bee2-3a5865ded52c",
    "data-name": "<Pfad>",
    x1: 158,
    y1: 154,
    x2: 158,
    y2: 80,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "0d5acd8d-53bb-4a2e-9f99-5ee026bf0410",
    "data-name": "<Pfad>",
    x1: 34,
    y1: 154,
    x2: 34,
    y2: 80,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "4a8343e4-8553-4ba0-8530-d64e4837c122",
    "data-name": "<Pfad>",
    d: "M34,118c0,9.42,28.87,20,62,20s62-10.58,62-20",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "5d87f741-d39d-4ab9-9009-6b9f6b80027e",
    "data-name": "<Pfad>",
    d: "M34,154c0,9.42,28.87,20,62,20s62-10.58,62-20",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "6297a6c4-4e54-4d95-ae32-6a404c8b6165",
    "data-name": "<Pfad>",
    d: "M68,43",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("path", {
    id: "7b0e00aa-55f3-4e76-9b0b-024b5e2c34d8",
    "data-name": "<Pfad>",
    d: "M68,74",
    transform: "translate(0 0)",
    fill: "none",
    stroke: "#6d6968",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 4
  }), /*#__PURE__*/React.createElement("line", {
    id: "1392a04a-f70a-4f42-980c-69b256b507ad",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 76,
    x2: 96,
    y2: 44,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "41780256-a62a-4697-967b-b7a8a5cdd5f9",
    "data-name": "<Pfad>",
    x1: 68,
    y1: 68,
    x2: 68,
    y2: 36,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "c9f2c017-a81d-4f8b-b89f-c4f900176f90",
    "data-name": "<Pfad>",
    x1: 124,
    y1: 68,
    x2: 124,
    y2: 36,
    fill: "none",
    stroke: "#e60000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "d6f1fc2c-190b-497e-b659-a05b1a5b9b9f",
    "data-name": "<Pfad>",
    x1: 96,
    y1: 32,
    x2: 96,
    y2: 28,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "6d5214a8-4f64-4d01-8bf1-801edf96bec7",
    "data-name": "<Pfad>",
    x1: 68,
    y1: 24,
    x2: 68,
    y2: 20,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("line", {
    id: "37f0687e-7ef9-48ca-92ce-bfc1530d8d93",
    "data-name": "<Pfad>",
    x1: 124,
    y1: 24,
    x2: 124,
    y2: 20,
    fill: "none",
    stroke: "#666",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8
  }), /*#__PURE__*/React.createElement("rect", {
    width: 192,
    height: 192,
    fill: "none"
  })));
}

var _default = ic_birthday__greeting;
exports.default = _default;